module.exports = __webpack_public_path__ + "img/signup_complete_bg.b9ee27ae.png";